import { FullReportAddress } from "./utils";
import { mapsServiceIcon, mapsServiceUrl, StringLimit } from "../../../Utils";
import { useSelector } from "react-redux";

export const ReportAddress = (props) => {
  const settings = useSelector(
    (state) => state.session?.currentUser?.settings
  );

  const { report } = props;

  const fullAddressStr = FullReportAddress(report) || "";

  const hasAddress =
    !!(report?.delivery_address?.address || report?.address) &&
    fullAddressStr.replace(/,|\s/g, "").length > 0;

  const mapsUrl = hasAddress
    ? mapsServiceUrl(fullAddressStr, settings?.preferred_maps_service)
    : null;

  const sectionContent = (
    <section
      className="px-4 py-5 sm:px-6"
      aria-labelledby="report-address-title"
    >
      <div className="flex items-center justify-between gap-4">
        <div className="min-w-0 flex-1">
          <h2
            id="report-address-title"
            className="text-lg font-medium leading-6 text-gray-900"
          >
            Oppdragsaddresse
          </h2>
          <p className="mt-1 max-w-2xl text-sm text-gray-500">
            <StringLimit text={FullReportAddress(report)} limit={40} />
          </p>
        </div>
        {hasAddress && (
          <div className="flex-shrink-0 text-indigo-600">
            {mapsServiceIcon(settings?.preferred_maps_service)}
          </div>
        )}
      </div>
    </section>
  );

  const className = `block w-full rounded-lg shadow transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 relative z-10 ${
    hasAddress
      ? "bg-white hover:bg-gray-50 cursor-pointer"
      : "bg-white cursor-default"
  }`;

  if (hasAddress && mapsUrl) {
    return (
      <a
        href={mapsUrl}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Vis oppdragsaddresse på kart"
        className={className}
      >
        {sectionContent}
      </a>
    );
  }

  return <div className={className}>{sectionContent}</div>;
};
